
<div class="flex-column flex__align-center full-stretch">


    <mat-card 
        class="padding-none responsive-card"
        [ngClass]="{
            'col-width-large':!(isSmallerScreenObs | async),
            'full-stretch':isSmallerScreenObs | async,
            'margin-standard-top':!(isSmallerScreenObs | async)
        }"
    >
        
        <mat-card-header #cardHeader class="border-primary-bottom padding-standard">
            <mat-card-title class="mat-headline-4 margin-none">{{'ss-auth.oidc-logout-title' | translate}}</mat-card-title>
        </mat-card-header>
        
        <mat-card-content fixedScroll [otherElements]="[header,footer]" class="flex-column padding-standard">

            <p class="margin-none">{{'ss-auth.oidc-logout-message' | translate}}</p>
            <p class="margin-none">{{'ss-auth.oidc-logout-message-2' | translate}}</p>

            
        </mat-card-content>
        
        <mat-card-footer #footer class="border-gray-top  padding-standard">
            <mat-card-actions class="padding-none responsive-actions min-height-none">
                <button mat-raised-button color="primary" class="full-width" (click)="routeToDashboard()"> {{'ss-auth.login' | translate}}</button>
            </mat-card-actions>
        </mat-card-footer>
    </mat-card>

</div>